import React from 'react';
import { Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import isEmpty from 'lodash/isEmpty';

function Checkbox({ id, checked, handleChange, width, height, label, meta, sm }) {
    let isInvalid = false;
    if (meta) {
        isInvalid = meta.touched && !isEmpty(meta.error);
    }

    return (
        <Col sm={sm}>
            <div className="d-flex flex-column">
                {label && (
                    <label
                        className="form-check-label"
                        htmlFor={id}
                    >
                        {label}
                    </label>
                )}
                <input
                    type="checkbox"
                    id={id}
                    className={cx('mt-2', { 'is-invalid': isInvalid })}
                    checked={checked}
                    onChange={handleChange}
                    style={{ width: width, height: height }}
                />
                {isInvalid && <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>}
            </div>
        </Col>
    );
}
Checkbox.defaultProps = {
    width: '',
    height: '',
    label: '',
    meta: null,
    sm: 3,
};
Checkbox.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    checked: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
    label: PropTypes.string,
    meta: PropTypes.object,
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
export default Checkbox;
